import { createReducer, Action, on } from '@ngrx/store';
import { IPipelineState, EPipelineStateStatus } from '../models/pipeline.model';
import {
  loadPipelines,
  loadPipelinesSuccess,
  loadPipelinesError,
  createPipelines,
  createPipelinesSuccess,
  createPipelinesError,
  updatePipelines,
  updatePipelinesSuccess,
  updatePipelinesError,
  deletePipelines,
  deletePipelinesSuccess,
  deletePipelinesError,
} from '../actions/pipeline.action';

const initialState: IPipelineState = {
  pipelines: [],
  status: EPipelineStateStatus.INITIALIZING,
  error: null,
  pagination: {
    current_page: 0,
    has_more_data: false,
    has_previous: false,
    page_size: 10,
    total_pages_count: 0,
  },
};

const pipelineReducer = createReducer(
  initialState,
  on(loadPipelines, (state, { pagination }) => {
    return {
      ...state,
      status: EPipelineStateStatus.LOADING,
      pagination: {
        ...state.pagination,
        pagination,
      },
    };
  }),
  on(loadPipelinesSuccess, (state, { pipelines, pagination }) => {
    return {
      ...state,
      status: EPipelineStateStatus.READY,
      pipelines,
      pagination,
    };
  }),
  on(loadPipelinesError, (state, { error }) => {
    return {
      ...state,
      state: EPipelineStateStatus.ERROR,
      error,
    };
  }),
  on(createPipelines, (state, {}) => {
    return {
      ...state,
      status: EPipelineStateStatus.LOADING,
      pagination: {
        ...state.pagination,
      },
    };
  }),
  on(createPipelinesSuccess, (state, {}) => {
    return {
      ...state,
      status: EPipelineStateStatus.UPDATED,
    };
  }),
  on(createPipelinesError, (state, { error }) => {
    return {
      ...state,
      state: EPipelineStateStatus.ERROR,
      error,
    };
  }),
  on(updatePipelines, (state, {}) => {
    return {
      ...state,
      status: EPipelineStateStatus.LOADING,
      pagination: {
        ...state.pagination,
      },
    };
  }),
  on(updatePipelinesSuccess, (state, {}) => {
    return {
      ...state,
      status: EPipelineStateStatus.UPDATED,
    };
  }),
  on(updatePipelinesError, (state, { error }) => {
    return {
      ...state,
      state: EPipelineStateStatus.ERROR,
      error,
    };
  }),
  on(deletePipelines, (state, {}) => {
    return {
      ...state,
      status: EPipelineStateStatus.LOADING,
      pagination: {
        ...state.pagination,
      },
    };
  }),
  on(deletePipelinesSuccess, (state, {}) => {
    return {
      ...state,
      status: EPipelineStateStatus.UPDATED,
    };
  }),
  on(deletePipelinesError, (state, { error }) => {
    return {
      ...state,
      state: EPipelineStateStatus.ERROR,
      error,
    };
  })
);

export function reducer(state: IPipelineState, action: Action) {
  return pipelineReducer(state, action);
}
